import {DigitalAssetASchema} from '@cohort/admin-schemas/digitalAsset';
import {DateSchema, EmailSchema, UserIdOrEmailRefinement} from '@cohort/shared/schema/common';
import {CurrencySchema} from '@cohort/shared/schema/common/currency';
import {OrderStatusSchema, OrderTypeSchema} from '@cohort/shared/schema/common/orders';
import {z} from 'zod';

export const OrderUserASchema = z.object({
  email: EmailSchema,
  walletAddress: z.string().nullable(),
});
export type OrderUserADto = z.infer<typeof OrderUserASchema>;

export const OrderASchema = z.object({
  id: z.string().uuid(),
  amount: z.number().int().min(0),
  campaignId: z.string().uuid(),
  createdAt: DateSchema,
  currency: CurrencySchema.nullable(),
  imageFileKey: z.string(),
  status: OrderStatusSchema,
  tokenId: z.number().int().min(1),
  type: OrderTypeSchema,
  user: OrderUserASchema,
  digitalAsset: DigitalAssetASchema.nullable(),
});
export type OrderADto = z.infer<typeof OrderASchema>;

export const CreateOrderDataASchema = z
  .object({
    campaignId: OrderASchema.shape.campaignId,
    tokenId: OrderASchema.shape.tokenId.optional(),
    // One of the following 2 options must be provided for identifying the user
    userId: z.string().uuid().optional().nullable(),
    email: EmailSchema.optional().nullable(),
  })
  .superRefine(UserIdOrEmailRefinement);
export type CreateOrderDataADto = z.infer<typeof CreateOrderDataASchema>;

export const CreateOrderResponseASchema = z.object({
  orderId: OrderASchema.shape.id,
});
export type CreateOrderResponseADto = z.infer<typeof CreateOrderResponseASchema>;
